module.exports = __webpack_public_path__ + "media/app/assets/races/void_elf_male-f2405ef34ddc35e5c49ff8917e2a1c33.png";